import React from "react";
export default class PinInput extends React.Component {
    render() {
        return (
            <input
                id={this.props.name}
                className="pin-digit"
                maxLength="1"
                name={this.props.name}
                value={this.props.value}
                onKeyPress={this.props.controlFunc}
                autoFocus={this.props.autoFocus}
                autoComplete="off"
                type="tel"
                pattern="[0-9]*"
            />
        );
    }
}
